<template lang="pug">
  .notification
    .notification__header
      .notification__title Пробный период завершен
      .notification__date {{ hours }}
    .notification__body
      p.notification__content Ваш конструктор заблокирован. Оплатите тариф, чтобы возобновить работу.
        br
        router-link.notification__link(
          @click.native="emitClick"
          title="Тарифы"
          :to="{name: 'payments'}"
        ) Посмотреть тарифы
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'OrderReceived',
  mixins: [notification]
};
</script>
